import { BadgeColor, MUIBadge } from 'components/common/MUIBadge'
import { ConversationListStatus, getConversationListStatus } from '../helpers/conversationListStatus'

import { ConversationSummaryDTO } from 'models/conversations'
import { FC } from 'react'
import { useChatWidget } from '../ChatWidget.context'
import { useTranslation } from 'react-i18next'

const BADGE_COLOR: Record<ConversationListStatus, BadgeColor> = {
  [ConversationListStatus.OPEN]: 'blue',
  [ConversationListStatus.IN_PROGRESS]: 'beige',
  [ConversationListStatus.AWAITING_YOU]: 'orange',
  [ConversationListStatus.RESOLVED]: 'gray',
  [ConversationListStatus.CLOSED]: 'gray',
}

const LABEL_KEY: Record<ConversationListStatus, string> = {
  [ConversationListStatus.OPEN]: 'chat:list_status.open',
  [ConversationListStatus.IN_PROGRESS]: 'chat:list_status.in_progress',
  [ConversationListStatus.AWAITING_YOU]: 'chat:list_status.awaiting_you',
  [ConversationListStatus.RESOLVED]: 'chat:overview.resolved',
  [ConversationListStatus.CLOSED]: 'chat:list_status.closed',
}

interface Props {
  conversation: ConversationSummaryDTO
}

export const ConversationStatusBadge: FC<Props> = ({ conversation }) => {
  const { t } = useTranslation(['chat'])
  const { currentUserId } = useChatWidget()
  const status = getConversationListStatus(conversation, currentUserId)

  return (
    <MUIBadge
      size="xs"
      color={BADGE_COLOR[status]}
      label={t(LABEL_KEY[status])}
      data-testid={`conversation-status-${conversation.id}`}
    />
  )
}
